export default __webpack_public_path__ + "search-examples-category-based-search-thumbnail-960-293cdb3f0aa5a8f0dafef74f9a734960.png";